export default __webpack_public_path__ + "/dist/images/6805886.png";